import { useContext } from "react";
import { Animated } from "react-animated-css";
import styled from "styled-components";
import { Element, scroller } from "react-scroll";
import { LanguageContext } from "../../components/LanguageContext";

import sabFace from "../../assets/sabFace.webp";
import masteringBG from "../../assets/masteringBG.webp";
import Player from "../../components/Player";
import tracks from "../../tracks";
import Button from "../../components/Button";

const Intro = ({ DialogTrigger, formStatus }) => {
  const { language } = useContext(LanguageContext);
  const text = {
    english: {
      mProd: "Music Producer",
      p1: "I'm passionate about pushing songs to their full potential and giving them the sonic character they deserve.",
      p2: "Getting to understand the artist's vision and making it come alive through the production and mixing process is both the most challenging and fun part of my job.",
      p3: "If you think we would be a good fit together to make and finish great music, feel free to contact me.",
      button: "Contact me",
      button2: "Listen to my work",
    },
    french: {
      mProd: "Producteur Musical",
      p1: "Je suis passionné par l'idée de pousser les chansons à leur plein potentiel et de leur donner le caractère sonore qu'elles méritent.",
      p2: "Comprendre la vision de l'artiste et la faire prendre vie à travers la production et le mixage est à la fois la partie la plus challengeante et la plus amusante de mon travail.",
      p3: "N'hésites pas à me contacter pour plus d'informations sur mes services.",
      button: "Contactez-moi",
      button2: "Écoutez ma musique",
    },
  };

  return (
    <Element name={"home"}>
      <Wrapper>
        <IntroWrap>
          <Animated
            animationIn="fadeInLeft"
            animationOut="fadeOut"
            isVisible={true}
          >
            <StyledFace src={sabFace} />
          </Animated>
          <TextWrap>
            <TitleWrap>
              <StyledH1>Sabien Prissette</StyledH1>
              <StyledH2>{text[language].mProd}</StyledH2>
            </TitleWrap>
            <PWrap>
              <StyledP>{text[language].p1}</StyledP>
              <StyledP>{text[language].p2}</StyledP>
              <StyledP>{text[language].p3}</StyledP>
            </PWrap>
          </TextWrap>
        </IntroWrap>

        <ButtonWrap>
          <Button
            text={text[language].button}
            width={"300px"}
            func={(e) => {
              e.preventDefault();
              scroller.scrollTo("contact", {
                duration: 1500,
                delay: 100,
                smooth: "easeInOutQuart",
                offset: -65,
              });
            }}
          />
          <Button
            text={text[language].button2}
            width={"300px"}
            func={(e) => {
              e.preventDefault();
              scroller.scrollTo("music", {
                duration: 1500,
                delay: 100,
                smooth: "easeInOutQuart",
                offset: -65,
              });
            }}
          />
        </ButtonWrap>
      </Wrapper>
    </Element>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  /* box-shadow: inset 0 0 0 1000px var(--overlay); */
  background: rgb(53, 124, 130);
  background: linear-gradient(
      180deg,
      rgba(53, 124, 130, 0.5) 0%,
      rgba(53, 124, 130, 0.5) 90%,
      rgba(53, 124, 130, 1) 100%
    ),
    url(${masteringBG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: clamp(640px, 92vh, 92vh);
  width: 100%;
  color: var(--text-color);
  @media (max-width: 1000px) {
    height: 100%;
  }
`;

const StyledH1 = styled.h1`
  font-size: 4rem;
  @media (max-width: 1000px) {
    text-align: center;
  }
  /* align-self: flex-end; */
`;

const StyledH2 = styled.h2`
  /* align-self: flex-end; */
  font-size: 2.4rem;
  @media (max-width: 1000px) {
    text-align: center;
  }
`;

const StyledP = styled.p`
  padding: 10px 0;
  @media (max-width: 1000px) {
    padding: 5px 0;
  }
`;

const StyledFace = styled.img`
  border-radius: 100%;
  margin: 2rem;
  margin-left: 0;
  height: auto;
  max-width: 320px;
  -webkit-box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  @media (max-width: 1000px) {
    margin: 10% 5% 5% 5%;
    width: 90%;
  }
`;
const IntroWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 90%;
  max-width: 1400px;
  background-color: var(--main-color);
  padding: 20px 20px;
  border-radius: 12px;
  -webkit-box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  margin: 40px 0;

  @media (max-width: 1000px) {
    flex-direction: column;
    margin: 40px 0;
    padding: 5%;
    padding-top: 0;
  }
`;
const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
`;
const PWrap = styled.div`
  background: white;
  padding: 12px;
  border-radius: 8px;
  -webkit-box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
  /* border: black solid 1px; */
  margin-top: 10px;
  @media (max-width: 1000px) {
    padding: 8px;
    width: 95%;
    align-self: center;
  }
`;

const ButtonWrap = styled.div`
  display: flex;
  width: 700px;
  justify-content: space-between;
  @media (max-width: 1000px) {
    flex-direction: column;
    width: fit-content;
    height: 300px;
    justify-content: space-evenly;
    align-items: center;
  }
`;

const TitleWrap = styled.div`
  color: white;
  margin-left: 12px;
  width: 100%;
  @media (max-width: 1000px) {
    margin-left: 0;
  }
`;
export default Intro;
